/**
 * Floating Hearts Animation
 * Hearts float from bottom to top with rotation animation
 */

const heartsCanvas = document.getElementById('hearts-canvas');
const heartsCtx = heartsCanvas.getContext('2d');

// Set canvas size
heartsCanvas.width = window.innerWidth;
heartsCanvas.height = window.innerHeight;

// Get settings from global variables (passed from Liquid)
const heartCount = window.heartCount || 25;
const heartColor = window.heartColor || '#BD2841';
const heartMoveSpeed = window.heartMoveSpeed || 5; // 1-10 scale
const heartRotateSpeed = window.heartRotateSpeed || 5; // 1-10 scale

// Calculate speed multipliers from 1-10 scale
const moveSpeedMultiplier = heartMoveSpeed / 5; // 5 is default (1x), 10 = 2x, 1 = 0.2x
const rotateSpeedMultiplier = heartRotateSpeed / 5;

const hearts = [];

// Convert hex color to rgba
function hexToRgba(hex, alpha) {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

// Heart particle constructor
function Heart() {
    this.reset();
    // Start from random Y position in the visible zone (bottom portion of screen)
    // Only spawn in bottom 10% to ensure hearts start at full opacity
    this.y = heartsCanvas.height * 0.9 + Math.random() * (heartsCanvas.height * 0.1 + 50);
}

Heart.prototype.reset = function () {
    this.x = Math.random() * heartsCanvas.width;
    this.y = heartsCanvas.height + 50; // Start from below screen
    this.size = Math.random() * 15 + 10; // Size between 10-25px
    this.speedY = (Math.random() * 1 + 0.5) * moveSpeedMultiplier; // Float speed with multiplier
    this.speedX = (Math.random() * 0.6 - 0.3) * moveSpeedMultiplier; // Horizontal drift with multiplier
    this.opacity = Math.random() * 0.4 + 0.3; // 0.3 to 0.7 opacity
    this.rotation = Math.random() * Math.PI * 2; // Initial rotation
    this.rotationSpeed = (Math.random() * 0.04 - 0.02) * rotateSpeedMultiplier; // Rotation speed with multiplier
};

// Update heart position
Heart.prototype.update = function () {
    this.y -= this.speedY; // Move upward
    this.x += this.speedX; // Slight horizontal drift
    this.rotation += this.rotationSpeed; // Rotate

    // Reset when heart goes above screen
    if (this.y < -50) {
        this.reset();
    }

    // Wrap horizontally
    if (this.x > heartsCanvas.width + 50) {
        this.x = -50;
    } else if (this.x < -50) {
        this.x = heartsCanvas.width + 50;
    }
};

// Draw heart shape with glowing border effect
Heart.prototype.draw = function () {
    // Calculate fade-out opacity based on Y position
    // Hearts start fading at 50% screen height and become invisible at ~10% from top
    const fadeStartY = heartsCanvas.height * 0.9; // Start fading at 50% height
    const fadeEndY = heartsCanvas.height * 0.4;   // Fully invisible at 10% from top

    let fadeMultiplier = 1;
    if (this.y < fadeStartY) {
        // Calculate linear fade: 1 at fadeStartY, 0 at fadeEndY
        const linearFade = Math.max(0, (this.y - fadeEndY) / (fadeStartY - fadeEndY));
        // Apply ease-out cubic for smoother transition: starts fast, slows down at end
        fadeMultiplier = 1 - Math.pow(1 - linearFade, 3);
    }

    // Apply fade to base opacity
    const currentOpacity = this.opacity * fadeMultiplier;

    // Skip drawing if completely invisible
    if (currentOpacity <= 0) {
        return;
    }

    heartsCtx.save();
    heartsCtx.translate(this.x, this.y);
    heartsCtx.rotate(this.rotation);
    heartsCtx.scale(this.size / 30, this.size / 30);

    // Create heart path function to reuse - traditional rounded heart shape
    const createHeartPath = () => {
        heartsCtx.beginPath();
        // Start at the top center dip
        heartsCtx.moveTo(0, -8);

        // Left lobe - rounded curve
        heartsCtx.bezierCurveTo(-2, -12, -12, -20, -18, -12);
        heartsCtx.bezierCurveTo(-24, -4, -20, 8, 0, 20);

        // Right lobe - rounded curve (mirror of left)
        heartsCtx.bezierCurveTo(20, 8, 24, -4, 18, -12);
        heartsCtx.bezierCurveTo(12, -20, 2, -12, 0, -8);

        heartsCtx.closePath();
    };

    // Draw glowing border (outer glow effect)
    createHeartPath();
    heartsCtx.shadowColor = hexToRgba(heartColor, currentOpacity);
    heartsCtx.shadowBlur = 8;
    heartsCtx.strokeStyle = hexToRgba(heartColor, currentOpacity * 1.2);
    heartsCtx.lineWidth = 3;
    heartsCtx.stroke();

    // Reset shadow for fill
    heartsCtx.shadowBlur = 0;

    // Fill with darker shade (create darker version of heart color)
    createHeartPath();
    // Darken the fill color by reducing RGB values
    const darkenColor = (hex, factor) => {
        const r = Math.floor(parseInt(hex.slice(1, 3), 16) * factor);
        const g = Math.floor(parseInt(hex.slice(3, 5), 16) * factor);
        const b = Math.floor(parseInt(hex.slice(5, 7), 16) * factor);
        return `rgba(${r}, ${g}, ${b}, ${currentOpacity})`;
    };
    heartsCtx.fillStyle = darkenColor(heartColor, 0.6);
    heartsCtx.fill();

    heartsCtx.restore();
};

// Create heart particles
for (let i = 0; i < heartCount; i++) {
    hearts.push(new Heart());
}

// Animation loop
function animateHearts() {
    heartsCtx.clearRect(0, 0, heartsCanvas.width, heartsCanvas.height);

    hearts.forEach(heart => {
        heart.update();
        heart.draw();
    });

    requestAnimationFrame(animateHearts);
}

// Start animation
animateHearts();

// Handle window resize
window.addEventListener('resize', () => {
    heartsCanvas.width = window.innerWidth;
    heartsCanvas.height = window.innerHeight;
});
